import $ from 'jquery';

export default () => {
  const $form = $('form.search');

  // Enabling dropdown
  $form.find('.ui.dropdown').dropdown({
    onChange: () => $form.submit(),
  });

  const isInputEmpty = (_, element) => $(element).val().length === 0;

  // Submit (ignore empty parameters)
  $form.on('submit', event => {
    $(event.target)
      .find('input[name], select[name]')
      .filter(isInputEmpty)
      .attr('name', '');
  });
};



// WEBPACK FOOTER //
// ./src/plugins/search.js